import React, { useEffect, useState } from "react";
import data1 from "./data1.json";
import { nanoid } from "nanoid";
import file from "../../assets/svg/file.svg";
import arrowRight from "../../assets/svg/arrow-right.svg";

const General1 = () => {
  const [data, setData] = useState([]);
  const [activeLines, setActiveLines] = useState([]);

  const setActiveLine = (id) => {
    if (activeLines.includes(id)) {
      setActiveLines(activeLines.filter((el) => el !== id));
    } else {
      setActiveLines([...activeLines, id]);
    }
  };
  useEffect(() => {
    setData(data1);
  }, []);

  return (
    <main className="general1">
      <table border="1" cellPadding="8" className="firstTable">
        <thead>
          <tr>
            <td></td>
            <td className="table-number">
              <b>Артикул</b>
            </td>
            <td></td>
            <td className="table-number">
              <b>Название</b>
            </td>
            <td>Категория товара </td>
            <td>Тип</td>
            <td>Прессованный товар</td>
            <td>Акция</td>
            <td>Дерево проверено</td>
            <td>Комментарий</td>
            <td>Материал</td>
            <td>На витрине</td>
            <td>На сайте машинки не показывать</td>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={nanoid()}
              // onClick={() => setActiveLine(index + 1)}
              // className={activeLines.includes(index + 1) ? "activeLine" : ""}
            >
              <td>
                {index === 0 && <img src={arrowRight} alt="ArrowRightIcon" />}
              </td>
              <td>{item.articleNumber}</td>
              <td className="icon-cell">
                <img src={file} alt="File" />
              </td>
              <td>{item.name}</td>
              <td>{item.productCategory}</td>
              <td>{item.type}</td>
              <td>{item.compressedProduct}</td>
              <td>{item.promotion}</td>
              <td>{item.treeChecked}</td>
              <td>{item.comment}</td>
              <td>{item.material}</td>
              <td>{item.onShowcase}</td>
              <td>{item.doNotShowOnWebsite}</td>
              {/* <td
                className={`clip-td ${
                  activeLines.includes(index + 1) ? "showClipIcon" : ""
                }`}
              >
                <img
                  src={yellowPaperclip}
                  alt="YellowPaperclip"
                  className="activeLine-paperclip"
                />
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
};

export default General1;
